export { default } from "./LessonOverviewTeacherTips";
export type { LessonOverviewTeacherTipProps } from "./LessonOverviewTeacherTips";
